import { updateFlavour } from '@stencil/flights-seo-reducers/src/SRP/redux/actions';

const setFlavour = (dispatch, flavour) => {
  if (typeof window !== 'undefined') {
    window.flavour = flavour;
  }
  dispatch(updateFlavour(flavour));
};
export const populateStoreSeoSrpFlights = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoSrpDistance = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoSrpHiFlights = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoSrpFlightSchedule = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoSrpHiFlightSchedule = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoSrpAirlineSchedule = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoSrpHiAirlineSchedule = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoSrpFlightsTo = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoSrpHiFlightsTo = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoSrpFlightsFrom = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoSrpHiFlightsFrom = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoSrpAirlines = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoSrpCheapFlights = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoFlightSchedule = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoSrpInternationalFlights = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoSrpHiInternationalFlights = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoSrpInternationalFlightSchedule = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoSrpHiInternationalFlightSchedule = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoSrpInternationalAirlineSchedule = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoSrpHiInternationalAirlineSchedule = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoIntlFlightsTo = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoHiIntlFlightsTo = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoIntlFlightsFrom = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoHiIntlFlightsFrom = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};

export const populateStoreSeoStaticPages = ({ flavour }, dispatch) => {
  setFlavour(dispatch, flavour);
};
